import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Eyebrow } from "@/components/Eyebrow";
import { Zap, Mail, Check } from "lucide-react";

const NEXT_TIER = { Starter: "Pro", Pro: "Enterprise", Enterprise: null };

export function UpgradeDialog({ info, onClose }) {
  const open = !!info;
  const plan = info?.plan || "Starter";
  const next = NEXT_TIER[plan];
  const email = info?.upgradeEmail || "";
  const subject = info?.upgradeSubject || "Upgrade my plan";
  const body = `Hi,\n\nI'm on the ${plan} plan and I've reached my limit for ${info?.kind || "usage"} (${info?.limit}). I'd like to upgrade${next ? ` to ${next}` : ""}.\n\nThanks!`;
  const mailto = email ? `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}` : null;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent style={{ background: "var(--panel)", border: "1px solid var(--cardhover)", maxWidth: 440 }} data-testid="upgrade-dialog">
        <DialogTitle className="sr-only">Plan limit reached</DialogTitle>
        <DialogDescription className="sr-only">You have reached a usage limit on your current plan.</DialogDescription>
        <Eyebrow>Plan Limit Reached</Eyebrow>

        <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 16 }}>
          <div style={{ width: 44, height: 44, borderRadius: 10, background: "rgba(24, 24, 27,0.12)", color: "var(--orange)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <Zap size={22} />
          </div>
          <div className="font-body" style={{ fontSize: 13.5, color: "var(--tsecondary)", lineHeight: 1.55 }} data-testid="upgrade-message">
            {info?.message}
          </div>
        </div>

        {next && (
          <div className="panel-card" style={{ marginTop: 18, padding: 14 }}>
            <div className="font-mono" style={{ fontSize: 10, color: "var(--tmuted)", textTransform: "uppercase", letterSpacing: "0.08em" }}>
              Upgrade to {next}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 7, marginTop: 10 }}>
              {["Higher monthly limits", "More saved brands", "Priority creative throughput"].map((t) => (
                <div key={t} className="font-body" style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "var(--tprimary)" }}>
                  <Check size={14} style={{ color: "var(--orange)", flexShrink: 0 }} /> {t}
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
          <button data-testid="upgrade-dismiss" className="btn-secondary" style={{ flex: 1 }} onClick={onClose}>
            Maybe later
          </button>
          {mailto && (
            <a data-testid="upgrade-contact" className="btn-primary" style={{ flex: 1, textDecoration: "none" }} href={mailto}>
              <Mail size={14} /> Contact to upgrade
            </a>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
